import { render } from "./LbDetails.vue?vue&type=template&id=0af9d037"
import script from "./LbDetails.vue?vue&type=script&lang=js"
export * from "./LbDetails.vue?vue&type=script&lang=js"

import "./LbDetails.vue?vue&type=style&index=0&id=0af9d037&lang=css"
script.render = render

export default script